import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthHeader from "../../UI/AuthHeader/AuthHeader";
import AuthSideMenu from "../../UI/AuthSideMenu/AuthSideMenu";
import { ButtonSubmitGreen } from "../../UI/Buttons/Buttons";
import Button from "../../UI/Buttons/Button";
import { PlainModalOverlay } from "../../UI/Modal/Modal";
import { Grid } from "@mui/material";
import Alert from '@mui/material/Alert';
import axios from 'axios';
import AuthInputs from "../../UI/Input/AuthInputs";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CancelIcon from '@mui/icons-material/Cancel';
import { IoMdRemoveCircle } from "react-icons/io";
import { FaEye } from "react-icons/fa";
import { SlEnvolopeLetter } from "react-icons/sl";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { VscChecklist } from "react-icons/vsc";
import { TbScreenshot } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useConfirm } from "material-ui-confirm";
import { checkAuthenticatedUser, getOrdinalDate, copyText } from "../../../utils/client-functions";
import { setResume, setFetching, setUserResumesAll, setUser, setProfileImg, setResumeServicesNumbers, setIsResumeSubbed, setResumeSubDuration } from "../../../redux/states";
import { useErrorSetter, useSuccessSetter } from '../../../hooks/useUiMessages';
import ResumePricing from "../../Pricing/ResumePricing";
import { useTheme } from "../../UI/Theme/ThemeContext";
import rhStyles from './ResumeHub.module.css';
import uploadBtnStyles from '../../UI/UploadPasteButton.module.css';
import UpgradePopup from '../../UI/SubscriptionPlans/UpgradePopup';
const screenWidth = window.innerWidth



const ResumeHub = () => {
    const dispatch = useDispatch();
    const confirm = useConfirm();
    const {userResumesAll, isResumeSubbed, resumeSubDuration, user, resumeServicesNumbers } = useSelector((state) => state.stateData);
    const navigate = useNavigate();
    const { themeName } = useTheme();
    const copyLink = useRef(null);
    const isAuth = localStorage?.getItem("token")
    const [modalOpen, setModalOpen] = useState(false)
    const [pricingOpened, setPricingOpened] = useState(false)
    const [authMenuOpen, setAuthMenuOpen] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [resumeForSearch, setResumeForSearch] = useState("");
    const [jobDesc, setJobDesc] = useState("");
    const [resumeIndex, setResumeIndex] = useState(0)
    const [actionString, setActionString] = useState('')
    // Image paste/upload states for job description (multi-image, smaller preview than AskMe.js)
    const [jobImagePreviews, setJobImagePreviews] = useState([]);
    const [jobImageFiles, setJobImageFiles] = useState([]);
    const fileInputRef = useRef(null);
    
    const errorSetter = useErrorSetter();
    const successSetter = useSuccessSetter();

    useEffect(() => {
        const fetchResume = async () => {
            dispatch(setFetching(true));
            try {
                const response = await axios.get("/user/resume", {
                    headers: {
                        "x-access-token": isAuth,
                    },
                });

                if (response?.data?.status === "unauthenticated") {
                    localStorage.removeItem("token");
                    navigate("/popin?resume-hub");
                    return;
                }

                const { resumes, profileImg, resumeTotalNumbers } = response?.data?.user || {};
                dispatch(setUserResumesAll(resumes || {}));
                setResumeForSearch(resumes || {});
                dispatch(setProfileImg(profileImg || ""));
                if (resumeTotalNumbers && typeof resumeTotalNumbers === 'object') {
                    dispatch(setResumeServicesNumbers({
                        resumeCreated: Number(resumeTotalNumbers.resumeCreated || 0),
                        jobsApplied: Number(resumeTotalNumbers.jobsApplied || 0),
                        coverLettersCreated: Number(resumeTotalNumbers.coverLettersCreated || 0),
                        interviewMocks: Number(resumeTotalNumbers.interviewMocks || 0),
                        followUpEmails: Number(resumeTotalNumbers.followUpEmails || 0),
                        jobConnectionRefresh: Number(resumeTotalNumbers.jobConnectRefresh || 0),
                    }));
                }
                dispatch(setIsResumeSubbed(response?.data?.user?.resumeSubscriptions?.subscribed));
                dispatch(setResumeSubDuration(response?.data?.user?.resumeSubscriptions?.duration));
                dispatch(setUser(response?.data?.user));
            } catch (error) {
                errorSetter("Failed to fetch resumes");
            } finally {
                dispatch(setFetching(false));
            }
        };

        // fetch only if we have no resumes loaded yet or user data is missing
        if (!userResumesAll || Object.keys(userResumesAll).length < 1 || !user || Object.keys(user).length < 1) {
            fetchResume();
        } else {
            setResumeForSearch(userResumesAll);
        }
        
    }, [dispatch, isAuth, navigate, userResumesAll, user, errorSetter]);

    // useEffect(() => {
    //     console.log(jobDesc);
        
    // }, [jobDesc]);

    // Clipboard paste handler for images + file input handling (smaller preview for ResumeHub)
    useEffect(() => {
        const handlePaste = (e) => {
            try {
                const items = e.clipboardData && e.clipboardData.items;
                if (!items) return;
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item.type && item.type.indexOf('image') !== -1) {
                        const blob = item.getAsFile();
                        if (blob) {
                            const maxBytes = 10 * 1024 * 1024; // 10MB
                            if (blob.size > maxBytes) {
                                errorSetter('Image larger than 10MB');
                                return;
                            }
                            if (jobImageFiles.length >= 5) {
                                errorSetter('Maximum 5 images allowed');
                                return;
                            }
                            const url = URL.createObjectURL(blob);
                            setJobImagePreviews(prev => [...prev, url].slice(0,5));
                            setJobImageFiles(prev => [...prev, blob].slice(0,5));
                            // don't break; allow multiple pasted images
                        }
                    }
                }
            } catch (_) {
                // no-op
            }
        };

        window.addEventListener('paste', handlePaste);
        return () => {
            window.removeEventListener('paste', handlePaste);
            jobImagePreviews.forEach(u => { try { URL.revokeObjectURL(u); } catch(_) {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobImagePreviews, jobImageFiles.length, errorSetter]);

    const handleFileSelectJob = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;
        const maxBytes = 10 * 1024 * 1024;
        const newPreviews = [];
        const newFiles = [];
        for (const f of files) {
            if (!f.type.startsWith('image/')) continue;
            if (f.size > maxBytes) { errorSetter('Image larger than 10MB'); continue; }
            if ((jobImageFiles.length + newFiles.length) >= 5) { errorSetter('Maximum 5 images allowed'); break; }
            const url = URL.createObjectURL(f);
            newPreviews.push(url);
            newFiles.push(f);
        }
        if (newFiles.length > 0) {
            setJobImagePreviews(prev => [...prev, ...newPreviews].slice(0,5));
            setJobImageFiles(prev => [...prev, ...newFiles].slice(0,5));
        }
        e.target.value = null;
    };

    const triggerFileSelectJob = () => {
        if (fileInputRef.current) fileInputRef.current.click();
    };

    const removeJobImagePreview = () => {
        jobImagePreviews.forEach(u => { try { URL.revokeObjectURL(u); } catch(_) {} });
        setJobImagePreviews([]);
        setJobImageFiles([]);
    };

    const removeSingleJobImage = (idx) => {
        setJobImagePreviews(prev => {
            const copy = [...prev];
            const [removed] = copy.splice(idx,1);
            try { if (removed) URL.revokeObjectURL(removed); } catch(_) {}
            return copy;
        });
        setJobImageFiles(prev => {
            const copy = [...prev];
            copy.splice(idx,1);
            return copy;
        });
    }

    const closeModal = () => {
        setModalOpen(false);
        removeJobImagePreview();
    }
    


    const toggleResumes = () => {
        setAuthMenuOpen(!authMenuOpen);
    };

    const goBackPrevPage = () => {
        navigate('/user/dashboard/resume');
    }

        const handleCopy = () => {
        if (copyLink.current) {
            const textToCopy = copyLink.current.textContent;
                        copyText(textToCopy)
                            .then(() => successSetter("Link copied to clipboard"))
                            .catch((err) => {
                                errorSetter("Failed to copy Link: " + (err?.message || 'Unknown error'));
                                try { window.prompt('Copy this link:', textToCopy); } catch(_) {}
                            });
        }
    };

    const handleReDownload = (index) => {
        // setTrueOpened(true)
        confirm({
            title: `Open "${resumeForSearch[index].storageDetails.name}" Resume?`,
            description: `Click OK to preview`,
        })
        .then(() => {
            //set only one resume to download
            dispatch(setResume(resumeForSearch[index]))
            navigate("/user/dashboard/resume?download");
        })
        .catch(() => {
            return    
        });
    }

    const coverLetterStart = (index) => {
        setResumeIndex(index)
        setActionString("CL")
        setModalOpen(true)
    }

    const jobIntStart= async (index) => {
        setResumeIndex(index)
        setActionString("Int")
        setModalOpen(true)
    }

    const handleGenerateCL =  async () => {
        const date = getOrdinalDate()
        const myResume = userResumesAll[resumeIndex]
        
        const imgUrl = myResume?.storageDetails?.imgUrl
        const template = myResume?.storageDetails?.template

        
        const prompt = `You are the best and most professional cover letter writer in the world, 
            with 100% ATS and employment success rate from your cover letter writings. Write a stunning professional 
            cover letter tailored to the job description: ${jobDesc} and my resume resume in object form: ${JSON.stringify(myResume)}, 
            pick out the candidate name from keys firstName for First Name and lastName for Last Name within 
            the basicInfo object of the resume; pick out the candidate's work history and all other elements 
            needed to write the best cover letter from the resume object and Date: ${date}. NOTES: Do not include any 
            links or addressing or contact details or place holders e.g [Your Email] [Your Mobile] [Hiring Manager’s Name] to the cover letter. 
            Start with Date, then Dear Hiring Manager and return just the cover letter, with no explanations`
        
        try {
            dispatch(setFetching(true))
            let response;
            if (jobImageFiles.length > 0) {
                const form = new FormData();
                jobImageFiles.forEach(f => form.append('images', f));
                form.append('prompt', prompt);
                response = await axios.post('/cover-letter', form, {
                    headers: { 'Content-Type': 'multipart/form-data', 'x-access-token': isAuth }
                });
                // clear preview after upload send
                removeJobImagePreview();
            } else {
                response = await axios.post("/cover-letter", { prompt }, {
                    headers: {
                        "x-access-token": isAuth,
                    },
                });
            }

            dispatch(setFetching(false))
            if (response?.data?.status === 'quota') {
                const statusCode = response.status;
                    if (statusCode === 403 && response.data.openPricing) {
                        setPricingOpened(true);
                    errorSetter(response.data.message || 'Free tier quota reached. Upgrade to continue.');
                    return;
                }
                if (statusCode === 429) {
                    errorSetter(response.data.message || 'Daily cover letter quota reached. Try again tomorrow.');
                    return;
                }
                errorSetter(response.data.message || 'Cover letter quota reached.');
                return;
            }

            localStorage.setItem("template", template)            
            localStorage.setItem("resume", JSON.stringify(myResume))            
            localStorage.setItem("imgUrl", imgUrl)
            localStorage.setItem("letter", response.data)
            dispatch(setFetching(false))
            successSetter("Your Cover Letter opens in a new tab in 3 seconds")
            //Navigate in a Cover Letter page
            setTimeout(() => {
                window.open("/cover-letter", "_blank");
            }, 3000);
        } catch (error) {
            dispatch(setFetching(false))
            const resp = error?.response;
            if (resp && resp.data && resp.data.status === 'quota') {
                const statusCode = resp.status;
                    if (statusCode === 403 && resp.data.openPricing) {
                        setPricingOpened(true);
                    errorSetter(resp.data.message || 'Free tier quota reached. Upgrade to continue.');
                    return;
                }
                if (statusCode === 429) {
                    errorSetter(resp.data.message || 'Daily cover letter quota reached. Try again tomorrow.');
                    return;
                }
                errorSetter(resp.data.message || 'Cover letter quota reached.');
                return;
            }
            errorSetter("Failed to generate Cover Letter, Try again")
        }
    }

    const handleGenerateInt =  async () => {
        const myResume = userResumesAll[resumeIndex]

        const interviewPrompt = `I am preparing for an upcoming job interview for the Job description provided (${jobDesc}), 
        and my resume used for the application is given here in string object form: (${JSON.stringify(myResume)}). 
        Please provide a detailed and comprehensive guide that includes the following:
        Common Interview Questions: List 15 typical questions I might be asked in order of descending importance, along with their corresponding correct answer, exactly as I should nswer them, using all the details I have provided and those you can find on the given company.
        Company Research: Do a research on the company provided above, its culture, values, and recent news or achievements and feed me with all the info you can find on them.
        Role-Specific Preparation: Important skills and qualifications related to the job, and how I can demonstrate my expertise in these areas during the interview.
        Behavioral Questions: Examples of behavioral questions and the STAR (Situation, Task, Action, Result) method to structure my responses.
        Questions to Ask the Interviewer: Thoughtful questions I can ask at the end of the interview to show my interest and engagement.
        Body Language and Presentation: Tips on how to present myself confidently and effectively during the interview.
        Follow-Up Strategy: Guidance on how and when to follow up after the interview.
        Thank you for your help in preparing me for this important opportunity!`

        localStorage.setItem("HFLHASIGFWFIVQJKVKJJBJKVSHDVHVIVIVIVHVhvhjavcdhuchch_Int_Prep-fu-em_aghgxtdRWYRDWY", interviewPrompt)
        successSetter("Your Interactive Interview Mock opens in 3 seconds")
        //Navigate in a Cask me page
        setTimeout(() => {
            window.open("/chat", "_blank");
        }, 3000);
        
    }


    const generate = (actionString) => { 
        // Allow submit if either text is sufficiently long or an image is attached
        const hasText = jobDesc && jobDesc.trim().length >= 20;
    const hasImage = jobImageFiles.length > 0;
        if (!hasText && !hasImage) {
            errorSetter("Provide a longer job description or upload an image")
            return
        }

        switch (actionString) {
            case "CL":
                handleGenerateCL()
                break;
            case "Int":
                handleGenerateInt()
                break;
            default:
                errorSetter("Something broke, reload and try again")
                break;
        }
    }

    const handleDeleteResume = async (index, imgUrl) => {
        try {
            //must await
            await checkAuthenticatedUser()
        } catch (error) {
            dispatch(setFetching(false));
            return navigate("/popin?resume");      
        }

        const resumeName = resumeForSearch[index]?.storageDetails?.name;

        confirm({
            title: `Delete "${resumeName}" Resume?`,
            description: `Click OK to delete selected resume forever`,
        })
        .then(async () => {
            dispatch(setFetching(true))
            let fileName = "";
            if (imgUrl) {
                try {
                    // Try parsing as full URL
                    const urlParts = new URL(imgUrl);
                    fileName = urlParts.pathname.split('/').pop();
                } catch (e) {
                    // fall back to string splitting if it's not a full URL (e.g. relative path)
                    fileName = imgUrl.split('/').pop();
                }
            }

            const body = {
                nameOfResume: resumeName,
                fileName: fileName || undefined
            };

            try {
                const response = await axios.post("/user/delete-resume", body, {
                    headers: {
                        "x-access-token": isAuth,
                    },
                });
                dispatch(setUserResumesAll(response.data.resume))
                setResumeForSearch(response.data.resume)
                dispatch(setFetching(false))
                successSetter("Resume Deleted")
            } catch (error) {
                dispatch(setFetching(false))
                errorSetter(error?.response?.data?.message || "Something went wrong. Try again")
            }
        })
        .catch(() => {
            dispatch(setFetching(false));
        });
    }

    const handleSearch = (e) => {
        const newSearchString = e.target.value;
        setSearchString(newSearchString);
    
        if (newSearchString.length === 0) {
            setResumeForSearch(userResumesAll);
        } else  {
            // Filter the resumes based on the search string
            const filteredData = userResumesAll.filter(item =>
                item.storageDetails.name.toLowerCase().includes(newSearchString.toLowerCase())
            );
            setResumeForSearch(filteredData);
        }
    };


    return (
        <div className="auth-container">
            <UpgradePopup />
            {/* For SIDE MENU */}
            <AuthSideMenu
                opened={authMenuOpen}
                hidden={!authMenuOpen}
                resumeSubDuration={resumeSubDuration}
                isResumeSubbed={isResumeSubbed}
                arrayDetails={[]}
                firstName={user.firstName}
            />
            <div style={{ width: "100%", padding: "0" }}>
                <div className="auth-bg-blob"></div>
            </div>

            <div className="auth-container-inner">
                {/* for TOP MENU */}
                <AuthHeader
                    authMenuOpen={authMenuOpen}
                    onClick={toggleResumes}
                    headerText="My Resumes"
                />

                <div style={{margin: '20px auto', width: screenWidth < 900 ? '100%' : '50%'}} onClick={() => setAuthMenuOpen(false)}>
                    <AuthInputs 
                        placeholder="Search resume by name" 
                        inputType="search" 
                        mb={3} 
                        mt={5} 
                        required={true} 
                        value={searchString}
                        onChange={handleSearch}
                    />
                </div> 

                {/* Summary counts */}
                <div style={{ width: screenWidth < 900 ? '100%' : '90%', margin: '0 auto 10px', }} onClick={() => setAuthMenuOpen(false)}>
                    <Card sx={{
                        ...styles.card,
                        border: '1px solid #5fbec5',
                        color: themeName === 'dark' ? '#fff' : '#000'
                    }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ color: themeName === 'dark' ? '#fff' : '#000' }}>Resumes</Typography>
                                    <Typography variant="h4" sx={{ color: themeName === 'dark' ? '#fff' : '#000' }}>{Array.isArray(userResumesAll) ? userResumesAll.length : 0}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ color: themeName === 'dark' ? '#fff' : '#000' }}>Cover Letters Created</Typography>
                                    <Typography variant="h4" sx={{ color: themeName === 'dark' ? '#fff' : '#000' }}>{Number(resumeServicesNumbers?.coverLettersCreated || 0)}</Typography>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </div>

                {Object.keys(userResumesAll).length < 1 ? (
                    <div style={styles.noResumes} onClick={() => setAuthMenuOpen(false)}>
                        <h4>Your Resumes Appear here</h4>
                        <div style={{width: '200px'}}>
                            <ButtonSubmitGreen onClick={goBackPrevPage}>Create Resume</ButtonSubmitGreen>
                        </div>
                    </div>
                ) : (
                    Object.keys(resumeForSearch).length < 1 ? (
                        <div style={styles.noResumes} onClick={() => setAuthMenuOpen(false)}>
                            <h4>No resume found</h4>
                        </div>
                    ) : (
                        <Grid container onClick={() => setAuthMenuOpen(false)}>
                            {resumeForSearch.map((item, index) => (
                                <Grid key={index} item xs={12} md={6} sx={styles.cardGrid}>
                                    <Card sx={{
                                        ...styles.card,
                                        border: '1px solid #5fbec5',
                                        color: themeName === 'dark' ? '#fff' : '#000'
                                    }}>
                                        
                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>                                            
                                            <CardContent sx={{ flex: '1 0 auto' }}>
                                                <Typography component="div" variant="h5" sx={{ color: themeName === 'dark' ? '#fff' : '#000' }}>
                                                    {item?.storageDetails?.name ? item.storageDetails.name.length > 40 ? `${item.storageDetails.name.slice(0, 40)}...` : item.storageDetails.name : 'Unnamed'}
                                                </Typography>
                                                {item?.storageDetails?.resumeLink && (
                                                    <div style={{...styles.link, color: themeName === 'dark' ? '#fff' : '#000'}} title="Copy Resume Link" onClick={handleCopy}>
                                                        <div style={{overflowX: 'hidden', whiteSpace: 'nowrap'}}>
                                                            <span>Copy Share Link</span> 
                                                            <span style={{ display: 'none'}} ref={copyLink}>
                                                                {item?.storageDetails?.resumeLink}
                                                            </span>
                                                        </div>
                                                        <div >
                                                            <ContentCopyIcon fontSize='small' />
                                                        </div>
                                                    </div>
                                                )}
                                                {item?.storageDetails?.buildDate && (
                                                    <Typography sx={{ ...styles.buildDate, color: themeName === 'dark' ? '#fff' : '#000' }}>
                                                        {item?.storageDetails?.buildDate}
                                                    </Typography>
                                                )}

                                            </CardContent>


                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-around', 
                                                paddingBottom: '1rem', 
                                                flexWrap: 'wrap', 
                                                gap: '10px',
                                                width: '100%',
                                                margin: '0 auto'
                                            }}>
                                                <div style={{ flex: '1 1 auto' }}>
                                                    <Button
                                                        width="100%"
                                                        secondaryLight={true}
                                                        color="#3E8F93"
                                                        $borderColor="#3E8F93"
                                                        clickHandle={() => handleReDownload(index)}
                                                    >
                                                        <FaEye style={{color: "#3E8F93", fontSize: ".9rem"}} />&nbsp;&nbsp; View Resume
                                                    </Button>
                                                </div>
                                                <div style={{ flex: '1 1 auto' }}>
                                                    <Button
                                                        width="100%"
                                                        secondaryLight={true}
                                                        color="#987070"
                                                        $borderColor="#987070"
                                                        clickHandle={() => coverLetterStart(index)}
                                                    >
                                                        <SlEnvolopeLetter style={{color: "#987070", fontSize: ".9rem"}} />&nbsp;&nbsp; Get Cover Ltr
                                                    </Button>
                                                </div>
                                                <div style={{ flex: '1 1 auto' }}>
                                                    <Button
                                                        width="100%"
                                                        secondaryLight={true}
                                                        color="#3a86ff"
                                                        $borderColor="#3a86ff"
                                                        clickHandle={() => jobIntStart(index)}
                                                    >
                                                        <VscChecklist style={{color: "#3a86ff", fontSize: ".9rem"}} />&nbsp;&nbsp; Interview Mock
                                                    </Button>
                                                </div>
                                                <div style={{ flex: '1 1 auto' }}>
                                                    <Button
                                                        width="100%"
                                                        secondaryLight={true}
                                                        color="rgba(158, 9, 9, 0.733)"
                                                        $borderColor="rgba(158, 9, 9, 0.733)"
                                                        clickHandle={() => handleDeleteResume(index, item?.storageDetails?.imgUrl)}
                                                    >
                                                        <IoMdRemoveCircle style={{color: "rgba(158, 9, 9, 0.733)", fontSize: ".9rem"}} />&nbsp;&nbsp; Delete Resume
                                                    </Button>
                                                </div>
                                            </div>
                                        </Box>

                                    </Card>
                                </Grid>
                            ))}          
                        </Grid>
                    )

                )}

            </div>

            {modalOpen && (
                <PlainModalOverlay>
                    <div style={styles.modalInner}>
                        <div className='prev-page' onClick={closeModal}>
                            <FaLongArrowAltLeft />
                        </div>
                        <h4>Paste job description into the field below.</h4>

                        <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                            <Alert sx={{padding: '0 5px', fontSize: '.7rem' }} severity="warning">This improves your score.</Alert>
                        </div>
                        
                        <div style={styles.descCont}>
                            <div className={rhStyles.descWrapper}>
                                {jobImagePreviews.length > 0 && (
                                    <div className={rhStyles.previewAnchor}>
                                        <div className={rhStyles.multiPreviewGridSmall}>
                                            {jobImagePreviews.map((src, idx) => (
                                                <div key={idx} className={rhStyles.imagePreviewInnerSmall}>
                                                    <img src={src} alt={`preview-${idx}`} className={rhStyles.imagePreviewImgSmall} />
                                                    <button onClick={() => removeSingleJobImage(idx)} title="Remove image" className={rhStyles.imagePreviewCancelSmall}>
                                                        <CancelIcon sx={{ fontSize: '16px' }} />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                <div className={rhStyles.uploadBtnAnchor}>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept="image/*"
                                        multiple
                                        onChange={handleFileSelectJob}
                                        className={rhStyles.hiddenFileInput}
                                    />
                                    <button onClick={triggerFileSelectJob} className={uploadBtnStyles.uploadPasteBtn} title="Upload image or paste text into field">
                                        <TbScreenshot style={{ color: '#fff', fontSize: '1.1rem' }} />
                                        <span className={uploadBtnStyles.uploadPasteBtnText}>Upload/Paste</span>
                                    </button>
                                </div>

                                <AuthInputs
                                  id={"jobDesc"}
                                  name="jobDesc"
                                  value={jobDesc}
                                  placeholder="Accepts Text, Images or Both!"
                                  multiline={true}
                                  buttonInInput={true}
                                  rows={6}
                                  maxRows={6}
                                  inputGridSm={12}
                                  onChange={(event) => setJobDesc(event.target.value)}
                                />
                            </div>
                        </div>

                        <div style={{width: '100%'}}>
                            <ButtonSubmitGreen onClick={() => generate(actionString)} >Generate</ButtonSubmitGreen>
                        </div>

                    </div>
                </PlainModalOverlay>
            )}

            {pricingOpened && (
                <ResumePricing closePricing={() => setPricingOpened(false)} open={pricingOpened} />
            )}
        </div>
    );
};

export default ResumeHub;

const styles = {
    cardGrid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '10px auto'
    },
    card: { 
        backgroundColor: 'transparent',
        borderRadius: '20px',
        color: 'inherit', 
        padding: '10px',
        width: screenWidth < 900 ? '100%' : '90%',
    },
    buildDate: {
        marginTop: '10px',
        marginBottom: '-10px',
        textAlign: 'right',
        fontSize: '.6rem',
        width: '100%'
    },
    link: {
        borderRadius: '20px',
        color: 'inherit',
        display: 'flex',
        alignItems:'center',
        justifyContent: 'space-between',
        backgroundColor: 'transparent',
        cursor: 'copy',
        margin: '5px 0',
        height: '35px',
        width: '100%',
        padding: '5px',
        zIndex: '1',
        fontSize: '.75rem',
    },
    leftCont: { 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'space-around', 
        flexWrap: 'wrap',
        width: '100%', 
    },
    descCont: {
        width: '100%',
        margin: '15px auto',
        padding: 0
    },
    greenBtnCont: {
        width: '100px',
        height: '25px'
    },
    noResumes: {
        boxSizing: 'border-box',
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '30vh', 
        width: '100%'
    }
}
